import { createFileRoute, redirect } from "@tanstack/react-router";

// Redirect slug cũ /bat-tu-detail → /bat-tu-chi-tiet (giữ backlink/SEO).
export const Route = createFileRoute("/bat-tu-detail")({
  beforeLoad: () => {
    throw redirect({ to: "/bat-tu-chi-tiet", replace: true });
  },
  component: () => null,
});
